import api from "@/_services/api";
import { actiDomain, apiDomain } from "@/_services/constants";

/**
 *
 * @typedef Entity
 * @property {number} id
 * @property {number} parentId
 * @property {string} name
 * @property {Array<Entity>} children
 */

/**
 * Gets an entity by its id
 * @param id{number}
 * @returns {Promise<Entity>}
 */
export const getEntityById = async (id) => {
  const { data } = await api.get(`${apiDomain}/entities/${id}`);

  return data;
};

/**
 * Returns all entities
 * @returns {Promise<Entity>}
 */
export const findEntities = async () => {
  const { data } = await api.get(`${apiDomain}/entities/tree`);

  return data;
};

/**
 * Changed the session active entity
 * @param id{number} id of the new entity to use
 * @returns {Promise<void>}
 */
export const changeActiveEntity = async (id) => {
  await api.post(`${actiDomain}changeActiveEntities/`, {
    entities_id: id,
    is_recursive: true,
  });
};
